import BaseComponent from "../../base/base_component";

export default class  ResponsibleGamingIconsComponentWrapper extends  BaseComponent{
    /**
     *
     * @type {string}
     */
    static CLASS = 'ResponsibleGamingIconsComponentWrapper';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-responsible_gaming_icons';

    /**
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-responsible-gaming-icons-component';

    /**
     * ResponsibleGamingIcons component provided by the regulation class
     * @type {null}
     * @private
     */
    _responsibleGamingIconsComponent = null;


    init(params) {
        super.init(params);
        this._responsibleGamingIconsComponent = this.serviceFactory.regulationService().getResponsibleGamingIconsComponent(params);
    }

    start() {
        if (this._responsibleGamingIconsComponent) {
            this._responsibleGamingIconsComponent.start();
            this.appendChildComponent(this._responsibleGamingIconsComponent);
        }
   }

}